import React from 'react';
import Text from './base';

const H2Alt = props => <Text defaultTag="h2" variant="h2Alt" {...props} />;

export default H2Alt;
